import API from 'util/API';
import { feeMatches, normalizeFeesResponse, uniqueFees } from 'util/processingFeeUtils';


export const getTodayDashboard = async () => {
  const response = await API.get('/getTodaySalesReport');
  // console.log('getTodaySalesReport response', JSON.stringify(response.data, null, 2));
  if (response && response.data && response.data) {
    return response.data;
  }
  return null;
};



export const getTodayDishReport = async () => {
  const response = await API.get('/getTodayDishReport');
  if (response && response.data && response.data.dishes) {
    return response.data.dishes;
  }
  return null;
};

// Processing fees are kept by the server outside the sales ledger; dates are whole days, YYYY-MM-DD.
// Resolves to { total, refundFeeTotal, fees }, see util/processingFeeUtils.
export const getProcessingFees = async (startDateStr, endDateStr) => {
  const response = await API.get(`/processingFees?startDateStr=${startDateStr}&endDateStr=${endDateStr}`);
  return normalizeFeesResponse(response && response.data);
};

// Every fee record of one POS transaction or one online order, whenever it was recorded.
export const getProcessingFeesOf = async ({ transactionId, orderNumber }) => {
  const query = transactionId
    ? `transactionId=${encodeURIComponent(transactionId)}`
    : `orderNumber=${encodeURIComponent(orderNumber)}`;
  const response = await API.get(`/processingFees?${query}`);
  return normalizeFeesResponse(response && response.data);
};

/**
 * Fee records of a POS transaction (`transactionId`) and/or its online orders (`orderNumbers`).
 * A server older than the per-transaction query answers 400 (it wants dates); then the fees are
 * read for the `fallbackWindow` ({ startDateStr, endDateStr }) and matched here.
 */
export const getProcessingFeesFor = async ({ transactionId = null, orderNumbers = [], fallbackWindow }) => {
  const queries = [
    ...(transactionId ? [{ transactionId }] : []),
    ...orderNumbers.map((orderNumber) => ({ orderNumber })),
  ];
  if (queries.length === 0) {
    return [];
  }
  try {
    const results = await Promise.all(queries.map(getProcessingFeesOf));
    return uniqueFees(results.flatMap((result) => result.fees));
  } catch (error) {
    if (!(error && error.response && error.response.status === 400) || !fallbackWindow) {
      throw error;
    }
    const { fees } = await getProcessingFees(fallbackWindow.startDateStr, fallbackWindow.endDateStr);
    return fees.filter((fee) => feeMatches(fee, transactionId, orderNumbers.map(String)));
  }
};

// Admin only: commission less Adyen's payment fee per merchant, and one merchant's payments when given.
export const getAdyenPaymentProfits = async (startDateStr, endDateStr, restaurantId = null) => {
  const merchant = restaurantId ? `&restaurantId=${encodeURIComponent(restaurantId)}` : '';
  const response = await API.get(
    `/admin/adyenPaymentProfits?startDateStr=${startDateStr}&endDateStr=${endDateStr}${merchant}`
  );
  return response.data;
};
